var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("default"),
      !_vm.hasSlot
        ? _c("div", { staticClass: "field-wrapper" }, [
            _vm.label
              ? _c("p", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
              : _vm._e(),
            _c("textarea", {
              attrs: {
                rows: _vm.rows,
                id: _vm.name,
                name: _vm.name,
                placeholder: _vm.placeholder,
              },
              domProps: { value: _vm.value },
              on: { focus: _vm.onFocus, input: _vm.onInput },
            }),
          ])
        : _vm._e(),
      _vm.showFieldFooter
        ? _c("div", { staticClass: "field-footer" }, [
            _c("div", { staticClass: "example-slot" }, [_vm._t("example")], 2),
            !_vm.hasSlot && _vm.maxlength > 0
              ? _c(
                  "span",
                  { staticClass: "counter", class: { over: _vm.isOverLimit } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formattedCurrentLength) +
                        "/" +
                        _vm._s(_vm.formattedMaxlength) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      !_vm.hasSlot && _vm.showError
        ? _c("p", { staticClass: "max-length-error" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }